var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSewageTank = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2,
  d: "M8.549 12.465h-3.42v1.476H1.9V2.9h3.228v1.476h3.42c.21-.865.813-1.476 1.541-1.476.718 0 1.317.601 1.537 1.476h3.888c3.084 0 5.557 3.1 5.557 6.862v6.91H22.1V22.1h-8.949v-3.953h1.354v-4.092c0-.898-.586-1.59-1.264-1.59h-1.615c-.2.935-.827 1.457-1.492 1.475-.675.02-1.337-.478-1.585-1.475zm6.056 7.01h-.344v1.298h6.73v-1.299zm1.01-5.42v4.093h4.347v-6.91c0-3.073-2.015-5.535-4.448-5.535H11.7v5.435h1.542c1.328 0 2.373 1.33 2.373 2.917zm-5.53-1.44h.004c.218 0 .5-.262.5-.802V5.029c0-.26-.07-.463-.168-.6-.099-.137-.222-.202-.336-.202-.217 0-.5.259-.5.802v6.784c0 .26.07.464.168.6.1.137.222.201.332.201zm-1.61-1.477V5.703H5.128v5.435zM4.02 4.227H3.01v8.387h1.01V4.226z"
})));
export default SvgSewageTank;